'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.arpej-numbers').length <= 0 ) {
        return
    }

    gsap.registerPlugin(ScrollTrigger)

    $('.arpej-numbers__number').each(function () {
        gsap.to(this, {
            scrollTrigger: {
                trigger: this,
                onEnter: () => {
                    let $this = $(this);
                    let countTo = $this.attr('data-count');

                    let if_pourcentage = $this.attr('data-pourcentage');

                    $({
                        countNum: $this.attr('data-init')
                    }).animate({
                        countNum: countTo
                    },{
                        duration: 1000,
                        easing: 'swing',
                        step: function() {
                            if(if_pourcentage == "1"){
                                $this.text(Math.floor(this.countNum) + " %");
                            }else{
                                $this.text(Math.floor(this.countNum));
                            }
                        },
                        complete: function() {
                            $this.text((this.countNum).toLocaleString());
                            if(if_pourcentage == "1"){
                                $this.text((this.countNum).toLocaleString() + " %");
                            }else{
                                $this.text((this.countNum).toLocaleString());
                            }
                        }
                    });
                }
            }
        })
    });
}
